import { css } from 'styled-components';

export const BorderRadius = css`
  border-radius: 0.25em;
`;

export const TransWithMuchEzCB = css`
  transition-timing-function: cubic-bezier(0.75, 0, 0.25, 1);
`;
